// app/javascript/controllers/event_dispatcher_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    name: String,
    payload: Object
  }

  connect() {
    console.log(`dispatching event ${this.nameValue}: ${JSON.stringify(this.payloadValue)}`)
    window.dispatchEvent(new CustomEvent(this.nameValue, {
      detail: this.payloadValue
    }))
    this.element.remove()
  }
}